import CaptionType from "consts/CaptionType";

const CaptionPOTD = [
  {
    type: CaptionType.PollOfTheDay,
    body: "CAPTION_POTD_1",
    translateBody: true,
  },
  {
    type: CaptionType.PollOfTheDay,
    body: "CAPTION_POTD_2",
    translateBody: true,
  },
  {
    type: CaptionType.PollOfTheDay,
    body: "CAPTION_POTD_3",
    translateBody: true,
  },
];

export default CaptionPOTD;
